import React, { useState } from 'react';
import Background from './Background';
import PublicHeader from './PublicHeader';
import WikiAppSidebar from './WikiAppSidebar';
import MainContent from './MainContent';
import Footer from "./Footer";
import { useSidebarCollapsed } from '../../hooks';

interface WikiLayoutProps {
  children: React.ReactNode;
}

const WikiLayout: React.FC<WikiLayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  // Свёрнутый сайдбар отдаёт место контенту — как в админке
  const { collapsed: sidebarCollapsed, toggle: toggleSidebar } = useSidebarCollapsed('wikiSidebarCollapsed');

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Background>
      {/* Main content wrapper */}
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <PublicHeader
          onDrawerToggle={handleDrawerToggle}
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={toggleSidebar}
        />
        <WikiAppSidebar
          mobileOpen={mobileOpen}
          onDrawerToggle={handleDrawerToggle}
          collapsed={sidebarCollapsed}
        />
        {/* fullWidth только на десктопе по смыслу: на мобиле MainContent и так во всю ширину */}
        <MainContent fullWidth={sidebarCollapsed}>{children}</MainContent>
      </div>
      {/* Footer */}
      <Footer />
    </Background>
  );
};

export default WikiLayout;